import { Loader2 } from 'lucide-react'
import { AppLogo }  from '@components/brand'

/**
 * PageLoader — full-viewport loading state.
 * Displays the After Summit logo above a spinner.
 * Used by Suspense boundaries and route guards during initialization.
 */
export function PageLoader() {
  return (
    <div className="page-loader" aria-label="Loading…">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
        <AppLogo height={100} variant="full" style={{ borderRadius: '16px', overflow: 'hidden' }} />
        <Loader2 className="page-loader__icon" aria-hidden="true" style={{ width: '32px', height: '32px' }} />
      </div>
    </div>
  )
}
